export const CACHE_TIME_NEAREST_TOURNAMENTS = 2 * 60 * 1000 // 5 minutes
export const CACHE_TIME_VIP_TOURNAMENTS = 2 * 60 * 1000 // 5 minutes
export const CACHE_TIME_ACTIVE_SUBSCRIPTIONS = 2 * 60 * 1000 // 5 minutes
export const TournamentsCacheKey = 'tournaments'
